import { ConfigurationBoard } from './configuration-board';

/**
 * Installation de la configuration
 */
export class ConfigurationInstallation {
  id?: string;

  /**
   * Nombre de lames obligatoire à afficher si c'est une configuration avec de la mixité de lame
   */
  boardNumber?: number;

  /**
   * Ordre dans lequel l'afficher
   */
  order: number;

  /**
   * Pose liée
   */
  installationId: number;

  /**
   * Liste des lames dans le cas d'un mixage
   */
  configurationBoards: ConfigurationBoard[];

  constructor(installationId: number, order: number, configurationBoards: ConfigurationBoard[], boardNumber?: number) {
    this.boardNumber = boardNumber;
    this.order = order;
    this.installationId = installationId;
    this.configurationBoards = configurationBoards;
  }
}
